var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDescription = function SvgDescription(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.334 10.666h5.333V12H5.334zm0-2.666h5.333v1.333H5.334zm4-6.667H4c-.733 0-1.333.6-1.333 1.333v10.667c0 .733.593 1.333 1.327 1.333H12c.734 0 1.334-.6 1.334-1.333v-8zm2.666 12H4V2.666h4.667V6H12z"
  })));
};
export default SvgDescription;